export const FuncionalidadesGeral = {
  all: 'sgof-func-full',
  dominios: {
    consultar: 'ouvidoria-func-consultar_dominios',
    visualizarValores: 'ouvidoria-func-visualizar_dominios_valores',
    visualizarInativos: 'ouvidoria-func-visualizar_dominios_inativos',
    visualiarValoresInativos: 'ouvidoria-func-visualizar_dominios_valores_inativos',
    cadastrar: 'ouvidoria-func-cadastrar_dominios',
    visualisar: 'ouvidoria-func-visualizar_dominios',
    editar: 'ouvidoria-func-editar_dominios',
    excluir: 'ouvidoria-func-excluir_dominios',
  },
  servicos: {
    consultar: 'ouvidoria-func-consultar_servicos',
    visualizarInativos: 'ouvidoria-func-visualizar_servicos_inativos',
    cadastrar: 'ouvidoria-func-cadastrar_servicos',
    visualisar: 'ouvidoria-func-visualizar_servicos',
    editar: 'ouvidoria-func-editar_servicos',
    excluir: 'ouvidoria-func-excluir_servicos',
  },
  assuntos: {
    consultar: 'ouvidoria-func-consultar_assuntos',
    visualizarInativos: 'ouvidoria-func-visualizar_assuntos_inativos',
    cadastrar: 'ouvidoria-func-cadastrar_assuntos',
    visualizar: 'ouvidoria-func-visualizar_assuntos',
    cadastrarFilhos: 'ouvidoria-func-cadastrar_assuntos_filhos',
    editar: 'ouvidoria-func-editar_assuntos',
    excluir: 'ouvidoria-func-excluir_assuntos',
  },
  metodos: {
    consultar: 'ouvidoria-func-consultar_metodos',
    visualizarParametros: 'ouvidoria-func-visualizar_metodos_parametros',
    visualizarInativos: 'ouvidoria-func-visualizar_metodos_inativos',
    visualizarParametrosInativos: 'ouvidoria-func-visualizar_metodos_parametros_inativos',
    cadastrar: 'ouvidoria-func-cadastrar_metodos',
    visualizar: 'ouvidoria-func-visualizar_metodos',
    testar: 'ouvidoria-func-testar_metodos',
    editar: 'ouvidoria-func-editar_metodos',
    excluir: 'ouvidoria-func-excluir_metodos',
  },
  parametros: {
    gerar: 'ouvidoria-func-gerar_metodos_parametros',
    cadastrar: 'ouvidoria-func-cadastrar_metodos_parametros',
    excluir: 'ouvidoria-func-excluir_metodos_parametros',
  },
  valores: {
    cadastrar: 'ouvidoria-func-cadastrar_dominios_valores',
    excluir: 'ouvidoria-func-excluir_dominios_valores',
  },
  perguntas: {
    consultar: 'ouvidoria-func-consultar_perguntas',
    visualizarInativas: 'ouvidoria-func-visualizar_perguntas_inativas',
    cadastrar: 'ouvidoria-func-cadastrar_perguntas',
    visualizar: 'ouvidoria-func-visualizar_perguntas',
    editar: 'ouvidoria-func-editar_perguntas',
    excluir: 'ouvidoria-func-excluir_perguntas',
  },
  secoes: {
    consultar: 'ouvidoria-func-consultar_secoes',
    visualizarPerguntas: 'ouvidoria-func-visualizar_secoes_perguntas',
    visualizarInativas: 'ouvidoria-func-visualizar_secoes_inativas',
    visualizarPerguntasInativas: 'ouvidoria-func-visualizar_secoes_perguntas_inativas',
    cadastrar: 'ouvidoria-func-cadastrar_secoes',
    visualizar: 'ouvidoria-func-visualizar_secoes',
    editar: 'ouvidoria-func-editar_secoes',
    excluir: 'ouvidoria-func-excluir_secoes',
  },
  associarSessaoPergunta: {
    visualizar: 'ouvidoria-func-visualizar_secoes_perguntas_vinculos',
    visualizarInativos: 'ouvidoria-func-visualizar_secoes_perguntas_vinculos_inativos',
    cadastrar: 'ouvidoria-func-cadastrar_secoes_perguntas',
    editar: 'ouvidoria-func-editar_secoes_perguntas',
    excluir: 'ouvidoria-func-excluir_secoes_perguntas',
    ordernar: 'ouvidoria-func-ordenar_secoes_perguntas',
    cadastrarVinculos: 'ouvidoria-func-cadastrar_secoes_perguntas_vinculos',
    editarVinculos: 'ouvidoria-func-editar_secoes_perguntas_vinculos',
    excluirVinculos: 'ouvidoria-func-excluir_secoes_perguntas_vinculos',
  },
  formularios: {
    consultar: 'ouvidoria-func-consultar_formularios',
    visualizarServicos: 'ouvidoria-func-visualizar_formularios_servicos_assuntos',
    visualizarInativos: 'ouvidoria-func-visualizar_formularios_inativos',
    visualizarServicosInativos: 'ouvidoria-func-visualizar_formularios_servicos_assuntos_inativos',
    cadastrar: 'ouvidoria-func-cadastrar_formularios',
    importar: 'ouvidoria-func-importar_formularios',
    visualizar: 'ouvidoria-func-visualizar_formularios',
    visualizarSecoes: 'ouvidoria-func-visualizar_formularios_secoes',
    visualizarSecoesInativas: 'ouvidoria-func-visualizar_formularios_secoes_inativos',
    visualizarSecoesDetalhes: 'ouvidoria-func-visualizar_formularios_secoes_detalhes',
    visualizarSecoesPerguntas: 'ouvidoria-func-visualizar_formularios_secoes_perguntas',
    visualizarSecoesPerguntasInativas:
      'ouvidoria-func-visualizar_formularios_secoes_perguntas_inativos',
    visualizarSecoesPerguntasVinculos:
      'ouvidoria-func-visualizar_formularios_secoes_perguntas_vinculos',
    visualizarSecoesPerguntasVinculosInativos:
      'ouvidoria-func-visualizar_formularios_secoes_perguntas_vinculos_inativos',
    publicar: 'ouvidoria-func-publicar_formularios',
    despublicar: 'ouvidoria-func-despublicar_formularios',
    visualizarVersoes: 'ouvidoria-func-visualizar_formularios_versoes',
    editar: 'ouvidoria-func-editar_formularios',
    excluir: 'ouvidoria-func-excluir_formularios',
  },
  associarFormulario: {
    cadastrar: 'ouvidoria-func-cadastrar_formularios_servicos_assuntos',
    excluir: 'ouvidoria-func-excluir_formularios_servicos_assuntos',
  },
  secoesFormulario: {
    editarCapa: 'ouvidoria-func-editar_formularios_secoes_capa',
    cadastrarPasso: 'ouvidoria-func-cadastrar_formularios_secoes_passo',
    editarPasso: 'ouvidoria-func-editar_formularios_secoes_passo',
    excluirPasso: 'ouvidoria-func-excluir_formularios_secoes_passo',
    cadastrarContinua: 'ouvidoria-func-cadastrar_formularios_secoes_continua',
    editarContinua: 'ouvidoria-func-editar_formularios_secoes_continua',
    excluirContinua: 'ouvidoria-func-excluir_formularios_secoes_continua',
    cadastrarContinuaPerguntas: 'ouvidoria-func-cadastrar_formularios_secoes_continua_perguntas',
    editarContinuaPerguntas: 'ouvidoria-func-editar_formularios_secoes_continua_perguntas',
    excluirContinuaPerguntas: 'ouvidoria-func-excluir_formularios_secoes_continua_perguntas',
    cadastrarContinuaPerguntasVinculos:
      'ouvidoria-func-cadastrar_formularios_secoes_continua_perguntas_vinculos',
    editarContinuaPerguntasVinculos:
      'ouvidoria-func-editar_formularios_secoes_continua_perguntas_vinculos',
    excluirContinuaPerguntasVinculos:
      'ouvidoria-func-excluir_formularios_secoes_continua_perguntas_vinculos',
    ordenar: 'ouvidoria-func-ordenar_formularios_secoes',
  },
  atendimento: {
    novoAtendimentoPresencial: 'ouvidoria-func-cadastrar_atendimento_presencial',
    novoAtendimentoTelefonico: 'ouvidoria-func-cadastrar_atendimento_telefonico',
    consultarAtendimentos: 'ouvidoria-func-consultar_atendimentos',
  },
  caixaEntrada: {
    consultar: 'ouvidoria-func-visualizar_caixa_de_entrada_de_comunicacoes',
    // Identificador GCA compartilhado com os endpoints de complementação.
    complementarInformacao: 'ouvidoria-func-complementar_informacao_de_comunicacao',
  },
  registroComunicacao: {
    // HU-008 / GCA 09.01: funcionalidade que autoriza o Registro Manual.
    cadastrarManualmente: 'ouvidoria-func-cadastrar_comunicacao_manualmente',
  },
  relatorios: {
    // HU-023 / CP11: autoriza a emissão do Relatório Estatístico de Comunicações.
    // O perfil que a concede ainda é a pendência PD04 do contrato da HU; enquanto ela não
    // fecha, a página inicial e o menu também aceitam quem enxerga a Caixa de Entrada, para
    // não esconder a funcionalidade de quem deve usá-la.
    estatisticoComunicacao: 'ouvidoria-func-emitir_relatorio_estatistico',
  },
}
